import expandPathTillNode from '../actions/expandPathTillNode';
import setMoveToFolderNodeViewState from '../actions/setMoveToFolderNodeViewState';
import { getStore } from 'owa-mail-store/lib/store/Store';
import { orchestrator } from 'satcheljs';

/**
 * Utility function which finds the path till the node and expands them.
 * @param rootId RootId of the tree
 * @param nodeId NodeId which needs to be found
 */
export function expandTillNode(rootId: string, nodeId: string) {
    if (rootId === nodeId) {
        setMoveToFolderNodeViewState(nodeId, { isExpanded: true });
        return true;
    }

    const folder = getStore().folders.folderTable.get(rootId);
    const childFolderIds = folder ? folder.childFolderIds : [];
    for (let i = 0; i < childFolderIds.length; i++) {
        if (expandTillNode(childFolderIds[i], nodeId)) {
            setMoveToFolderNodeViewState(rootId, { isExpanded: true });
            return true;
        }
    }

    return false;
}

/**
 * Orchestrator which expands node till the given node.
 */
export default orchestrator(expandPathTillNode, actionMessage => {
    const { rootId, nodeId } = actionMessage;
    expandTillNode(rootId, nodeId);
});
